import { combineReducers } from 'redux';
import { newCampaignInterfaceReducer, NewCampaignInterfaceState } from '@domain/partnerships/partners/mobees/new-campaign/interface/interface.state';
import {
    CampaignState,
    mobeesNewCampaignReducer,
} from '@domain/partnerships/partners/mobees/new-campaign/campaign/campaign.state';
import { mobeesAdsReducer } from '@domain/partnerships/partners/mobees/new-campaign/ads/ad.state';
import { AdState } from '@domain/partnerships/partners/mobees/new-campaign/ads/ad.types';
import { mobeesFormReducer } from './form/form.state';

export interface NewCampaignState {
    ads: AdState;
    campaign: CampaignState;
    interface: NewCampaignInterfaceState;
    form: any;
}

export const newCampaignReducer = combineReducers({
    interface: newCampaignInterfaceReducer,
    campaign: mobeesNewCampaignReducer,
    ads: mobeesAdsReducer,
    form: mobeesFormReducer,
});
